import styled from "styled-components";

export const TechnologiesContainer = styled.section`
  position: relative;
  overflow: hidden;
  padding: clamp(4rem, 7vw, 6rem) clamp(1.5rem, 6vw, 6rem);
  background: radial-gradient(
      circle at top right,
      rgba(111, 76, 255, 0.25),
      transparent 45%
    ),
    radial-gradient(circle at bottom left, rgba(255, 112, 205, 0.15), transparent 40%),
    ${({ theme }) => theme.backgroundColor.dark};
  color: ${({ theme }) => theme.color.light};
`;

export const TechnologiesIntro = styled.div`
  max-width: 48rem;
  margin: 0 auto 3rem;
  text-align: center;
`;

export const TechnologiesHeader = styled.h2`
  font-size: clamp(2rem, 4vw, 2.75rem);
  margin-bottom: 0.75rem;
`;

export const TechnologiesSubheader = styled.p`
  color: ${({ theme }) => theme.color.lightGray};
  line-height: 1.6;
  margin: 0;
`;

export const TechnologiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 1.25rem;
`;

export const TechnologyCard = styled.div`
  padding: 1.25rem;
  border-radius: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 15, 21, 0.75);
  backdrop-filter: blur(18px);
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.35);
  transition: transform 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(255, 255, 255, 0.2);
  }
`;

export const TechnologyBadge = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.12);
  margin-bottom: 1rem;

  img {
    width: 60%;
    height: 60%;
    object-fit: contain;
  }

  span {
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 0.05em;
  }
`;

export const TechnologyName = styled.p`
  font-weight: 600;
  margin: 0;
`;

export const TechnologyMeta = styled.span`
  display: block;
  margin-top: 0.35rem;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.color.lightGray};
`;

export const ToolsetWrapper = styled.div`
  margin-top: 3rem;
  padding: 1.75rem;
  border-radius: 1.25rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const ToolsetHeader = styled.h3`
  margin: 0 0 0.25rem;
  font-size: 1.3rem;
`;

export const ToolsetDescription = styled.p`
  margin: 0 0 1.25rem;
  color: ${({ theme }) => theme.color.lightGray};
`;

export const ToolsetRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
`;

export const ToolsetChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 1rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.4);
  color: ${({ theme }) => theme.color.light};
  font-size: 0.9rem;
  font-weight: 500;
`;

export const ChipIcon = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);

  img {
    width: 70%;
    height: 70%;
    object-fit: contain;
  }

  span {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
  }
`;